var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChipMobile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconography"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 13.4533C8.27333 13.4533 8.5 13.2267 8.5 12.9533C8.5 12.68 8.27333 12.4533 8 12.4533C7.72667 12.4533 7.5 12.68 7.5 12.9533C7.5 13.2267 7.72667 13.4533 8 13.4533Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2334 15H4.76669C4.48003 15 4.20669 14.8867 4.00669 14.6867C3.80669 14.4867 3.69336 14.2133 3.69336 13.9267V2.08001C3.69336 1.79334 3.80669 1.52001 4.00669 1.32001C4.20669 1.12001 4.48003 1.00667 4.76669 1.00667H11.2267C11.5134 1.00667 11.7867 1.12001 11.9867 1.32001C12.1867 1.52001 12.3 1.79334 12.3 2.08001V13.9267C12.3 14.2133 12.1867 14.4867 11.9867 14.6867C11.7867 14.8867 11.5134 15 11.2267 15H11.2334ZM11.2334 13.92V11.9733H4.76669V13.92H11.2334ZM4.76669 2.08001V10.9067H11.2267V2.08001H4.76669Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChipMobile);
export default __webpack_public_path__ + "static/media/ic-chip-mobile.4b7f4fe507ba63400f1558fd92b778de.svg";
export { ForwardRef as ReactComponent };